

























































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';
import { snowSports, footSports, bikeSports } from '~/utils/runConstants.js';
import { replaceUrl } from '~/utils/explorer.js';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import DestinationJumbo from '~/components/partials/DestinationJumbo.vue';
import DestinationRespectsCard from '~/components/cards/DestinationRespectsCard.vue';
import PlaySolid from '~/components/icons/PlaySolid.vue';
import EventFeed from '~/components/lists/EventFeed.vue';
import ProvidersFeed from '~/components/lists/ProvidersFeed.vue';
import BlogFeed from '~/components/lists/BlogFeed.vue';
import DestinationRoutes from '~/components/partials/DestinationRoutes.vue';
import PhotosFeed from '~/components/lists/PhotosFeed.vue';
import DestinationStickyMenu from '~/components/menus/DestinationStickyMenu.vue';
import Breadcrumb from '~/components/partials/Breadcrumb.vue';
import ReceptionCard from '~/components/cards/ReceptionCard.vue';
import TouristCard from '~/components/cards/TouristCard.vue';
import GlobalSwiper from '~/components/partials/GlobalSwiper.vue';
import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import FacebookSolid from '~/components/icons/FacebookSolid.vue';
import InstagramOutline from '~/components/icons/InstagramOutline.vue';
import MarkdownContainer from '~/components/partials/MarkdownContainer.vue';
import CustomAccordion from '~/components/partials/CustomAccordion.vue';

@Component({
  components: {
    CustomAccordion,
    MarkdownContainer,
    ChevronRightSolid,
    DestinationJumbo,
    DestinationRespectsCard,
    PlaySolid,
    EventFeed,
    ProvidersFeed,
    BlogFeed,
    DestinationRoutes,
    PhotosFeed,
    DestinationStickyMenu,
    Breadcrumb,
    ReceptionCard,
    GlobalSwiper,
    ProfileRunSportTag,
    TouristCard,
    FacebookSolid,
    InstagramOutline,
  },
  middleware: ['noauth'],
  computed: {
    ...mapState('explorer', [
      'destination',
      'destinationEventsSuggestions',
      'destinationPartners',
      'destinationProvidersSuggestions',
      'destinationContacts',
      'destinationTourists',
      'destinationRoutesWithTracks',
      'destinationWeather',
      'sports',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.destination?.description?.trim().replace(/<\/?[^>]+(>|$)/g, "");
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.destination.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.destination.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: self.$thumbnailUrl(self.destination.header_pictures[0], 1200),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer/destinations/${self.$slugify(self.destination.title)}-${self.destination.id}`,
        },
      ],
    };
  },
  async asyncData ({ store, route, error, app }) {
    const errorInstance: any = error;

    if (
      route.params.destinationid.split('-').pop() === '' ||
      isNaN(Number(route.params.destinationid.split('-').pop()?.trim()))
    ) {
      return errorInstance({
        statusCode: 404,
        response: { data: { detail: 'Unknown Destination' } },
      });
    }

    const routeId: string | undefined = route.params.destinationid.split('-').pop()?.trim();

    try {
      if (route.query?.preview) {
        await store.dispatch('explorer/getDestinationPreview', {
          id: routeId,
          token: route.query.preview,
          lang: store.state.lang.locale,
        });
      } else {
        await store.dispatch('explorer/getDestination', {
          id: routeId,
          lang: store.state.lang.locale,
        });
      }
    } catch (e) {
      return errorInstance({
        statusCode: e.response.status,
        response: { data: { detail: app.i18n.t(e.response.data.detail) } },
      });
    }

    await store.dispatch('explorer/getDestinationEventsSuggestions', {
      destination_id: routeId,
      lang: store.state.lang.locale,
    });

    await store.dispatch('explorer/getDestinationPartners', {
      id: routeId,
    });

    await store.dispatch('explorer/getDestinationProvidersSuggestions', {
      destination_id: routeId,
      lang: store.state.lang.locale,
    });

    await store.dispatch('explorer/getDestinationContacts', {
      id: routeId,
      lang: store.state.lang.locale,
    });

    await store.dispatch('explorer/getDestinationTourists', {
      id: routeId,
      lang: store.state.lang.locale,
    });

    await store.dispatch('explorer/getDestinationRoutesWithTracks', {
      destination_id: routeId,
      lang: store.state.lang.locale,
    });

    if (store.state.explorer.destination?.id === Number(routeId)) {
      const lat: number = store.state.explorer.destination.locations[0].lat;
      const long: number = store.state.explorer.destination.locations[0].long;

      try {
        await store.dispatch('explorer/getDestinationWeather', {
          lat,
          long,
        });
      } catch {

      }
    }
    if (!store.state.explorer.sports.length) {
      await store.dispatch('explorer/getSports', { lang: store.state.lang.locale });
    }
  },
})
export default class ExplorerDestinationId extends Vue {
  destination: Types.DestinationItem;
  destinationEventsSuggestions: Types.Event[];
  destinationPartners: Types.PartnerItem[];
  destinationProvidersSuggestions: Types.Provider[];
  destinationContacts: Types.ReceptionCenter[];
  destinationTourists: Types.TourismOffice[];
  destinationRoutesWithTracks: Types.Route[];
  destinationWeather: any;
  locale: string;
  sports: Types.SportItem[];

  sportsToSend: Types.SportOption[] = [];
  oldPlatforms: { id: string, src: string }[] = [
    { id: 'TRAIL', src: '/img/home/logo__full__trail__monochrome.png' },
    { id: 'NORDIC', src: '/img/home/logo__full__nordicwalk__monochrome.png' },
    { id: 'R_BIKES', src: '/img/home/logo__full__bike__monochrome.png' },
    { id: 'SKI_RANDO', src: '/img/home/logo__full__skitouring__monochrome.png' },
  ];

  shouldDisplayMenu: boolean = false;

  /*
    We get route tracks from store values, then we will create a new array from
    it using the attributes we want so they will be displayed in
    DestinationRoutes.
  */
  get routesTracks () {
    const array: {difficulty: string, track: any, id: number}[] = [];
    this.destinationRoutesWithTracks.map((r: Types.Route) => {
      if (r.type === 'ROUTE') {
        array.push(
          {
            difficulty: r.difficulty ? this.routeColor(r.difficulty) : '#9FA4AE',
            track: r.track_simplified ? JSON.parse(r.track_simplified) : {},
            id: r.id,
          },
        );
      }
    });
    return array;
  }

  /*
    DestinationRoutes component will display universes filtered inside the
    template. We create universes based on destination sports. If no filter is
    applied, we show all of them.

    As a route can be with a type of ROUTE or SPOT, it is decided to split both
    types into two distinct universes. If so, for i.e., Trail Running universe
    will be displayed twice, one with number routes, one with number of spots.
  */
  get routesFeed () {
    const arrayOfSports = this.sportsToSend.slice(0);

    arrayOfSports.map((s: any) => {
      s.routes = [];
      this.destinationRoutesWithTracks.map((r: any) => {
        if (s.id === r.sport?.id && r.type === 'ROUTE') {
          s.routes?.push(r);
          s.type = 'ROUTE';
        } else if (s.id === r.sport?.id && r.type === 'SPOT') {
          const spotElement: any = arrayOfSports.find((test: any) => test.type === 'SPOT' && test.id === s.id);
          if (spotElement === undefined) {
            const object: any = {
              checked: s.checked,
              icon_name: s.icon_name,
              id: s.id,
              imageName: s.imageName,
              name: s.name,
              routes: [],
              type: "SPOT",
            };
            object.routes.push(r);
            arrayOfSports.push(object);
          } else {
            spotElement?.routes.push(r);
          }
        }
      });
    });
    var arrayOfParentSports: any = [];
    arrayOfSports.forEach((element) => {
      // find index element in list of all sports
      const indexSportInList = this.sports.findIndex(obj => obj.id === element.id);
      // take parent id of element in list of all sports
      const parentId = this.sports[indexSportInList].parent_id;
      // if parent_id isn't empty
      if (parentId) {
        // search if parent is already in the given sports
        const alreadyInSports = arrayOfParentSports.findIndex((obj: { id: number; }) => obj.id === parentId);
        // if not, add it
        if (alreadyInSports === -1) {
          const indexOfParent = this.sports.findIndex(obj => obj.id === parentId);
          arrayOfParentSports.push({
            'id':this.sports[indexOfParent].id,
            'name':this.sports[indexOfParent].title,
            'icon_name': this.sports[indexOfParent].icon_name,
            'checked':false,
            'routes': element.routes,
            'type':element.type,
          });
        } else if (element.routes) {
          element.routes.forEach((route: any) => {
            const alreadyInRoutes = arrayOfParentSports[alreadyInSports].routes.findIndex((obj: { id: any; }) => obj.id === route.id);
            if (alreadyInRoutes === -1) {
              arrayOfParentSports[alreadyInSports].routes.push(route);
            }
          });
        }
      } else {
        arrayOfParentSports.push(element);
      }
    });
    return arrayOfParentSports.filter((sport: { routes: string | any[]; }) => sport.routes?.length);
  }

  /*
    We create the sport array to be used mostly for DestinationRoutes. We use
    the static sports local array and destination's sports to create a final
    array containing translated sports (with associated icon) that match.
  */
  get sportsSent () {
    const runConstants = [...snowSports, ...bikeSports, ...footSports];

    const sportsSent: Types.SportItem[] = this.destination?.sports.map((s: Types.SportItem) => {
      return {
        id: s.id,
        name: s.title,
        checked: false,
        icon_name: s.icon_name,
      };
    });

    for (let i = 0; i < sportsSent.length; i++) {
      for (let j = 0; j < runConstants.length; j++) {
        if (sportsSent[i].icon_name === runConstants[j].iconName) {
          sportsSent[i].imageName = runConstants[j].imageName;
        }
      }
    }
    return sportsSent;
  }

  /*
    Returns an array of this.destination.old_platform to be looped in template
    if they match this.oldPlatforms datas
  */
  get oldPlatformType () {
    const arrayOfOldPlatforms: string[] = [];

    /* eslint array-callback-return: 0 */
    this.destination.old_platform.map((platform: string) => {
      this.oldPlatforms.map((o: { id: string, src: string }) => {
        if (platform === o.id) arrayOfOldPlatforms.push(o.src);
      });
    });

    return arrayOfOldPlatforms;
  }

  /*
    This computed constructs a link with every sport of destination in query, so a
    filter will be applied when going to /explorer/destination page on events tab.
  */
  get linkToEvents () {
    return `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=events`;
  }

  /*
    This computed constructs a link with every sport of destination in query, so a
    filter will be applied when going to /explorer/destination page on providers
    tab.
  */
  get linkToProviders () {
    return `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=providers`;
  }

  /* Computed skeleton handle */
  get destinationIsEmpty () {
    return objectIsEmpty(this.destination);
  }

  /* Returns reactive breadcrumb links with some store values */
  get breadcrumbMenu () {
    return [
      { path: '/', name: this.$t('explorer.destinations.breadcrumb.home') },
      { path: '/explorer?tab=destinations', name: this.$t('explorer.destinations.breadcrumb.explorer') },
      { path: '', name: this.destination?.title, isActive: true },
    ];
  }

  /* Returns reactive submenu links with some store values */
  get subMenuLinks () {
    return [
      { link: '#description', name: this.$t('explorer.destinations.submenu.description'), isDisplayed: true },
      { link: '#routes', name: this.$t('explorer.destinations.submenu.routes'), isDisplayed: this.destinationRoutesWithTracks.length > 0 },
      { link: '#events', name: this.$t('explorer.destinations.submenu.events'), isDisplayed: this.destinationEventsSuggestions.length > 0 },
      { link: '#providers', name: this.$t('explorer.destinations.submenu.providers'), isDisplayed: this.destinationProvidersSuggestions.length > 0 },
      // { link: '#articles', name: this;$t('explorer.destinations.submenu.articles'), isDisplayed: true },
      { link: '#photos', name: this.$t('explorer.destinations.submenu.photos'), isDisplayed: this.destination.media.length > 0 },
      { link: '#technical-infos', name: this.$t('explorer.destinations.submenu.practical'), isDisplayed: this.destination.access || this.destinationContacts.length > 0 || this.destinationTourists.length > 0 },
    ];
  }

  /*
    For the EventFeed, we filter children based on sports filter inside template
  */
  get eventsFilteredBySports () {
    if (this.sportsToSend.some(s => s.checked)) {
      const array: Types.Event[] = [];
      this.sportsToSend.map((s: Types.SportOption) => {
        this.destinationEventsSuggestions.map((e: Types.Event) => {
          e.sports.map((eSport: Types.SportItem) => {
            if (s.checked && s.id === eSport.id) {
              array.push(e);
            }
          });
        });
      });
      return array;
    }
    return this.destinationEventsSuggestions;
  }

  /*
    Slices this.sports right away in SSR mode to avoid unexpected mutations
    when manipulating this.sports
  */
  @Watch('sportsSent', { immediate: true })
  updateSports (val: Types.SportOption[]) {
    this.sportsToSend = val.slice(0);
  }

  mounted () {
    if (process.client) {
      // We will display sticky menu when user has scrolled a certain amount
      window.addEventListener('scroll', this.displayStickyMenu);
    }

    window.dataLayer.push({
      'Destination': this.destination.title,
      'DestinationID': this.destination.id,
    });

    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO.
    */
    replaceUrl(
      this.$route.params.destinationid,
        `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/destinations/${this.$slugify(this.destination.title)}`,
        this.$slugify(this.destination?.title),
    );
  }

  beforeDestroy () {
    // Removes scroll event listener
    if (process.client) window.removeEventListener('scroll', this.displayStickyMenu);
  }

  /* Will display sticky menu when user has reached "destinationTitle" div */
  displayStickyMenu () {
    if (process.client) {
      const stickyDiv: any = document.getElementById('destinationTitle');
      const coords: any = stickyDiv.getBoundingClientRect();

      this.shouldDisplayMenu = coords.bottom <= 0;
    }
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/destination-placeholder.png";
  }

  /* Returns route color to be used in map based on route's difficulty */
  routeColor (val: number) {
    switch (val) {
      case 0: return '#9FA4AE';
      case 1: return '#3FA535';
      case 2: return '#009FE3';
      case 3: return '#CD171A';
      case 4: return '#000';
      default: return '#9FA4AE';
    }
  }
}
